function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import CriticalHigh from 'svg/mobileReports/Critical-high.svg';
import CriticalLow from 'svg/mobileReports/Critical-low.svg';
import messages from '../../../../../messages';
import { KPI_TYPES } from '../../../../../constants';
import styles from './Cells.pcss';
const RangeNameForType = {
    [KPI_TYPES.AVERAGE_PRE_MEAL]: 'preMeal',
    [KPI_TYPES.AVERAGE_OVERALL]: 'postMeal',
    [KPI_TYPES.AVERAGE__STRICT_POST_MEAL]: 'postMeal'
};
const getRangeStatus = (value, type, standards, conversion)=>{
    const rangeName = RangeNameForType[type];
    const range = standards[rangeName];
    if (!range || !value) return undefined;
    if (value > conversion.toDisplay(range.highThreshold)) {
        return 'high';
    }
    if (value < conversion.toDisplay(range.lowThreshold)) {
        return 'low';
    }
    return 'target';
};
const getFieldValue = (type, value, conversion)=>{
    if (type === KPI_TYPES.INJECTIONS) {
        const [fastActingRatio, longActingRatio] = value;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles['cell__field--injection'],
            children: [
                fastActingRatio ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        fastActingRatio,
                        "%"
                    ]
                }) : /*#__PURE__*/ _jsx("div", {}),
                longActingRatio ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        longActingRatio,
                        "%"
                    ]
                }) : /*#__PURE__*/ _jsx("div", {})
            ]
        });
    }
    if (value === null) return null;
    switch(type){
        case KPI_TYPES.VERY_HIGH:
            return /*#__PURE__*/ _jsxs("div", {
                className: styles['cell__field--critical'],
                children: [
                    /*#__PURE__*/ _jsx(CriticalHigh, {}),
                    /*#__PURE__*/ _jsx("div", {
                        children: value
                    })
                ]
            });
        case KPI_TYPES.VERY_LOW:
            return /*#__PURE__*/ _jsxs("div", {
                className: styles['cell__field--critical'],
                children: [
                    /*#__PURE__*/ _jsx(CriticalLow, {}),
                    /*#__PURE__*/ _jsx("div", {
                        children: value
                    })
                ]
            });
        case KPI_TYPES.PERSENT_OF_READING_IN_RANGE:
            return /*#__PURE__*/ _jsxs("div", {
                children: [
                    value,
                    "%"
                ]
            });
        case KPI_TYPES.AVERAGE_PRE_MEAL:
        case KPI_TYPES.AVERAGE__STRICT_POST_MEAL:
        case KPI_TYPES.AVERAGE_OVERALL:
            if (!value) return null;
            return value.toFixed(conversion.unit === 'MG_DL' ? 0 : 1);
        default:
            return value;
    }
};
const CellField = ({ type, value, standards, conversion })=>{
    const rangeStatus = getRangeStatus(value, type, standards, conversion);
    const FieldValue = getFieldValue(type, value, conversion);
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.cell__field, {
            [styles['cell__field--high']]: rangeStatus === 'high',
            [styles['cell__field--target']]: rangeStatus === 'target',
            [styles['cell__field--low']]: rangeStatus === 'low'
        }),
        children: FieldValue
    });
};
const Cell = (props)=>{
    useStyles(styles);
    const { type } = props;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cell,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.cell__title,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.summaries[type]))
            }),
            /*#__PURE__*/ _jsx(CellField, _object_spread({}, props))
        ]
    });
};
export default Cell;
